var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 text-center"},[_c('i',{staticClass:"fa fa-circle-o-notch fa-spin"}),_vm._v(" Loading...\n    ")])])])
}]

export { render, staticRenderFns }